import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom'; 
import './NavBar.css';
import '../App.css';

function NavBar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if(window.innerWidth <= 800) {
            setButton(false);
        } else {
            setButton(true);
        }
    };

    useEffect(() => {
        showButton();
        window.addEventListener('resize', showButton);
        return () => window.removeEventListener('resize', showButton);
    }, []);

    return (
      <>
        <nav className="navbar">
          <div className="navbar-container">
            <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
              <img src="/images/lucasburgessdev_logo.png" alt="Logo" className="navbar-logo-img" />
              <i 
              // className="fas fa-database"
              ></i>LucasBurgessDev
            </Link>
            <div className="menu-icon" onClick={handleClick}>
              <i className={click ? "fas fa-times" : "fas fa-bars"} />
            </div>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <Link to="/" className="nav-links" onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/projects"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Projects
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link
                  to="/contactme"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Contact Me
                </Link>
              </li> */}
              {/*                        <li className='nav-item'>
                            <Link to='/resume' className='nav-links' onClick={closeMobileMenu}>
                                Resume
                            </Link>
                        </li>
                         <li className='nav-item'>
                            <Link to='/extra-projects' className='nav-links' onClick={closeMobileMenu}>
                                Extra Projects
                            </Link>
                        </li>*/} 
                        <li className='nav-item'>
                            <Link to='/blog' className='nav-links' onClick={closeMobileMenu}>
                                Blog
                            </Link>
                        </li>
            </ul>
          </div>
        </nav>
      </>
    );
}

export default NavBar